import styled from 'styled-components';
import {Button, EMPHASIS, SubHeading} from '@forecast-it/design-system';
import type {ActivityTimelineItem_activity$key} from './__generated__/ActivityTimelineItem_activity.graphql';
import {ActivityTimeline} from './ActivityTimeline';

interface Props {
	entries: readonly ActivityTimelineItem_activity$key[];
	onViewAll: () => void;
	/** Passed through so an inbound email can name its sender. */
	requesterEmail?: string;
}

const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${p => p.theme.sys.spacing[200]};
`;
const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${p => p.theme.sys.spacing[300]};
`;

/** How many entries the overview shows before handing over to the Activity tab. */
const PREVIEW_COUNT = 3;

/**
 * The last few things that happened, on the overview.
 *
 * Renders through the same `ActivityTimeline` as the Activity tab, so an entry
 * cannot look one way here and another way there. The overview's job is only to
 * decide how many and to offer the way to the rest.
 */
export function RecentActivityPreview({entries, onViewAll, requesterEmail}: Props) {
	// The backend emits the timeline oldest-first, so the most recent entries are at
	// the end; reverse them so the newest reads first, as in the Activity tab.
	const recent = entries.slice(-PREVIEW_COUNT).reverse();

	return (
		<Section>
			<Header>
				<SubHeading>Recent activity</SubHeading>
				<Button emphasis={EMPHASIS.LOW} onPress={onViewAll}>
					See all
				</Button>
			</Header>
			<ActivityTimeline timeline={recent} requesterEmail={requesterEmail} emptyText="No activity yet." />
		</Section>
	);
}
